import type {ListMaterialFunctionsSearch} from "../-types";

import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";

import {materialFunctionsRouteApi} from "../-route-api";

export function MaterialFunctionsPending() {
  const search = materialFunctionsRouteApi.useSearch() as ListMaterialFunctionsSearch;
  const perPage = search.perPage ?? 20;

  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
          <div className="flex @lg:hidden">
            <ToolbarSkeleton.Button className="w-10" />
          </div>
        </div>
        <ToolbarSkeleton.Actions className="hidden @lg:flex">
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>

      <TableSkeleton columns={5} rows={perPage} />
    </PageContainerSkeleton>
  );
}
